import { useState, useEffect, useMemo } from 'react'
import {
  initialQueryState,
  OptionsHelper,
  useDebounce,
} from '../../../../../../../_metronic/helpers'

import { useQueryRequest } from '../../../core/QueryRequestProvider'
import { CustomSelect, Input, IOption, Label } from '../../../../../../components'

export const AtendimentosListSearchComponent = () => {
  const { updateState } = useQueryRequest()

  const [filters, setFilters] = useState({
    estado: undefined as IOption<number> | undefined,
    dataInicial: undefined as string | undefined,
    protocolo: '',
  })

  const debouncedFilters = useDebounce(filters, 500)

  const search = useMemo(() => {
    return [
      debouncedFilters.dataInicial ? `solicitacao>${debouncedFilters.dataInicial}` : '',
      debouncedFilters.estado ? `estado:${debouncedFilters.estado.value}` : '',
      debouncedFilters.protocolo ? `protocolo~*${debouncedFilters.protocolo}*` : '',
    ]
      .filter(Boolean)
      .join(',')
  }, [debouncedFilters])

  useEffect(() => {
    updateState({
      search,
      ...initialQueryState,
    })
  }, [search, updateState])

  return (
    <div className='container'>
      <div className='row mb-0'>
        <div className='col-lg-4'>
          <Label className='pb-2'>Protocolo</Label>
          <Input
            placeholder='Digite o protocolo'
            value={filters.protocolo}
            onChange={(e) => setFilters((prev) => ({ ...prev, protocolo: e.target.value }))}
          />
        </div>
        {/* <div className='col-lg-4'>
          <Label className='pb-2'>A partir de</Label>
          <DateInput
            placeholder='Selecione a data inicial'
            value={filters.dataInicial || ''}
            onChange={(e) => setFilters((prev) => ({ ...prev, dataInicial: e.target.value }))}
          />
        </div> */}
        <div className='col-lg-4'>
          <Label className='pb-2'>Estado</Label>
          <CustomSelect
            placeholder='Selecione um estado'
            onChange={(estado) => setFilters((prev) => ({ ...prev, estado }))}
            fetchOptions={OptionsHelper.getOptionsEstadosAtendimento}
          />
        </div>
      </div>
    </div>
  )
}
